// Centralized route configuration
export const ROUTES = {
  // Public routes
  LANDING: '/',
  SIGNIN: '/signin',

  // Dashboard routes
  DASHBOARD: '/dashboard',
  DASHBOARD_PASSWORD: '/dashboard/dashboard-password',

  // Dashboard sub-routes
  BRANDS: '/dashboard/brands',
  CATEGORY: '/dashboard/category',
  CUSTOMERS: '/dashboard/customers',
  INVOICES: '/dashboard/invoices',
  SALES: '/dashboard/sales',
  STOCK: '/dashboard/stock',
  MEETUPS: '/dashboard/meetups',
  WARRANTY_CHECK: '/dashboard/warranty-check',
  DEALER_BILLS: '/dashboard/dealer-bills',
  DEALERS: '/dashboard/dealers',
  AI_ASSISTANT: '/dashboard/ai-assistant',
  PRICE_LIST: '/dashboard/priceList',
  SCRAP_STOCK: '/dashboard/scrapStock',
  REVIEWS: '/dashboard/reviews',
  CLAIMS: '/dashboard/claims',

  // API routes
  API: {
    AUTH: '/api/auth',
    TEST_PERFORMANCE: '/api/test-performance',
  },

  // Error routes
  AUTH_ERROR: '/auth/error',
} as const;

// Route groups for easier management
export const ROUTE_GROUPS = {
  DASHBOARD_ROUTES: [
    ROUTES.DASHBOARD,
    ROUTES.BRANDS,
    ROUTES.CATEGORY,
    ROUTES.CUSTOMERS,
    ROUTES.INVOICES,
    ROUTES.SALES,
    ROUTES.STOCK,
    ROUTES.MEETUPS,
    ROUTES.WARRANTY_CHECK,
    ROUTES.CLAIMS,
    ROUTES.DEALER_BILLS,
    ROUTES.DEALERS,
    ROUTES.AI_ASSISTANT,
    ROUTES.PRICE_LIST,
    ROUTES.SCRAP_STOCK,
    ROUTES.REVIEWS,
  ],

  PUBLIC_ROUTES: [ROUTES.LANDING, ROUTES.SIGNIN],

  ALLOWED_WHEN_LOCKED: [
    ROUTES.MEETUPS,
    ROUTES.BRANDS,
    ROUTES.CATEGORY,
    ROUTES.CUSTOMERS,
    ROUTES.SALES,
    ROUTES.STOCK,
    ROUTES.INVOICES,
    ROUTES.CLAIMS,
    ROUTES.DEALER_BILLS,
    ROUTES.DEALERS,
    ROUTES.PRICE_LIST,
    ROUTES.SCRAP_STOCK,
    ROUTES.WARRANTY_CHECK,
    ROUTES.REVIEWS,
  ],
} as const;

// Computed route groups
export const AUTHENTICATED_ROUTES = [...ROUTE_GROUPS.DASHBOARD_ROUTES] as const;

// Helper functions
export const isDashboardRoute = (path: string): boolean => {
  return path.startsWith(ROUTES.DASHBOARD);
};

export const isSignInRoute = (path: string): boolean => {
  return path === ROUTES.SIGNIN;
};

export const isDashboardPasswordRoute = (path: string): boolean => {
  return path === ROUTES.DASHBOARD_PASSWORD;
};

export const isAllowedWhenLocked = (path: string): boolean => {
  return ROUTE_GROUPS.ALLOWED_WHEN_LOCKED.includes(path as any);
};

export const isPublicRoute = (path: string): boolean => {
  return ROUTE_GROUPS.PUBLIC_ROUTES.includes(path as any);
};

// Navigation items for sidebar
export const NAVIGATION_ITEMS = [
  {
    href: ROUTES.DASHBOARD,
    label: 'Dashboard',
    icon: 'MdDashboard',
  },
  {
    href: ROUTES.BRANDS,
    label: 'Brands',
    icon: 'FaTags',
  },
  {
    href: ROUTES.CATEGORY,
    label: 'Category',
    icon: 'TbCategoryPlus',
  },
  {
    href: ROUTES.STOCK,
    label: 'Stock',
    icon: 'FaCarBattery',
  },
  {
    href: ROUTES.INVOICES,
    label: 'Invoices',
    icon: 'FaFileInvoice',
  },
  {
    href: ROUTES.SALES,
    label: 'Sales',
    icon: 'FaFileInvoice',
  },
  {
    href: ROUTES.CUSTOMERS,
    label: 'Customers',
    icon: 'FaUserFriends',
  },
  {
    href: ROUTES.REVIEWS,
    label: 'Reviews',
    icon: 'FaStar',
  },
  {
    href: ROUTES.WARRANTY_CHECK,
    label: 'Warranty Check',
    icon: 'FaShieldAlt',
  },
  {
    href: ROUTES.CLAIMS,
    label: 'Battery Claims',
    icon: 'FaExchangeAlt',
  },
  {
    href: ROUTES.DEALERS,
    label: 'Dealers',
    icon: 'FaHandshake',
  },
  {
    href: ROUTES.MEETUPS,
    label: 'Meetups',
    icon: 'FaCalendarAlt',
  },
] as const;

export default ROUTES;
